var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0869 13.4725V12.0867C12.0869 11.3516 11.7948 10.6466 11.275 10.1268C10.7552 9.60696 10.0502 9.31494 9.31514 9.31494H3.77171C3.03661 9.31494 2.33161 9.60696 1.81182 10.1268C1.29202 10.6466 1 11.3516 1 12.0867V13.4725",
    stroke: "#454D66",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54369 6.54343C8.07446 6.54343 9.3154 5.30249 9.3154 3.77171C9.3154 2.24094 8.07446 1 6.54369 1C5.01291 1 3.77197 2.24094 3.77197 3.77171C3.77197 5.30249 5.01291 6.54343 6.54369 6.54343Z",
    stroke: "#454D66",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6e509a8ae45fac144fad472240240514.svg";
export { ForwardRef as ReactComponent };